import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "../components/ui/use-toast";
import { fetch } from "./fetch";

const updateBookingContractSigned = async (bookingId: string, contractSigned: boolean) => {
  return fetch(`/api/bookings/${bookingId}/contract-signed`, "PATCH", { contractSigned });
};

export const useBookingContractSignedMutation = (bookingId: string) => {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: (contractSigned: boolean) => updateBookingContractSigned(bookingId, contractSigned),
    onSuccess: (_, contractSigned) => {
      toast({
        title: "Success",
        description: contractSigned ? "Contract marked as signed." : "Contract marked as not signed.",
        variant: "default",
      });
      queryClient.invalidateQueries({ queryKey: ["bookingYachtOfferData", bookingId] });
    },
    onError: (error: any) => {
      toast({
        title: "Error",
        description: error.message || "Failed to update contract status.",
        variant: "destructive",
      });
    },
  });
};
